import React from "react";
import Layout from "./Layout";
import { useAuthStore } from "../store/authStore";
import ProfileSidebar from "./ProfileSidebar";

import { FaUser, FaEnvelope, FaPhone, FaCalendarAlt } from "react-icons/fa";

export default function Profile() {
  const user = useAuthStore((state) => state.user);

  if (!user) {
    return null;
  }

  return (
    <Layout>
      {/* =========================
          WELCOME SECTION
      ========================= */}
      <section className="bg-[#FFF8EC] px-6 md:px-16 py-8 mb-3">
        <div className="mx-auto flex flex-col md:flex-row items-center gap-6">
          {/* Profile Circle */}
          <div className="w-28 h-28 rounded-full bg-white border-4 border-white shadow-md flex items-center justify-center">
            <FaUser className="text-5xl text-[#FF945B]" />
          </div>

          {/* Welcome Text */}
          <div className="text-center md:text-left">
            <h2 className="text-4xl md:text-5xl font-serif text-light_primary mb-2">
              Welcome, {user.name}
            </h2>

            <p className="text-gray-600 mt-2 text-base">
              Manage your account and orders
            </p>
          </div>
        </div>
      </section>

      {/* =========================
          ACCOUNT SECTION
      ========================= */}
      <section className="px-6 lg:px-12 md:px-12 sm:px-12 xs:px-10 xxs:px-8 py-6 md:py-10 lg:py-10 sm:py-10 xs:py-8 xxs:py-6 mx-auto bg-white">
        <div className="mx-auto grid grid-cols-1 md:grid-cols-[270px_1fr] gap-8">
          {/* REUSABLE SIDEBAR */}
          <ProfileSidebar />

          {/* =========================
              PROFILE CARD
          ========================= */}
          <div className="bg-white border border-gray-200 rounded-xl shadow-sm p-6 md:p-8">
            <div className="flex items-center justify-between border-b border-gray-200 pb-5 mb-6">
              <h3 className="text-2xl font-semibold text-gray-900">
                My Profile
              </h3>
            </div>

            <div className="space-y-5">
              {/* Name */}
              <div className="flex items-center gap-4 pb-4 border-b border-dashed border-gray-200">
                <div className="w-11 h-11 rounded-full bg-[#FFF3E5] flex items-center justify-center shrink-0">
                  <FaUser className="text-[#E87932]" />
                </div>

                <div>
                  <p className="text-sm text-gray-500">Full Name</p>

                  <p className="text-base font-medium text-gray-800 mt-1">
                    {user.name || "-"}
                  </p>
                </div>
              </div>

              {/* Email */}
              <div className="flex items-center gap-4 pb-4 border-b border-dashed border-gray-200">
                <div className="w-11 h-11 rounded-full bg-[#FFF3E5] flex items-center justify-center shrink-0">
                  <FaEnvelope className="text-[#E87932]" />
                </div>

                <div>
                  <p className="text-sm text-gray-500">Email Address</p>

                  <p className="text-base font-medium text-gray-800 mt-1">
                    {user.email || "-"}
                  </p>
                </div>
              </div>

              {/* Phone */}
              <div className="flex items-center gap-4 pb-4 border-b border-dashed border-gray-200">
                <div className="w-11 h-11 rounded-full bg-[#FFF3E5] flex items-center justify-center shrink-0">
                  <FaPhone className="text-[#E87932]" />
                </div>

                <div>
                  <p className="text-sm text-gray-500">Phone Number</p>

                  <p className="text-base font-medium text-gray-800 mt-1">
                    {user.phone || "-"}
                  </p>
                </div>
              </div>

              {/* Member Since */}
              <div className="flex items-center gap-4">
                <div className="w-11 h-11 rounded-full bg-[#FFF3E5] flex items-center justify-center shrink-0">
                  <FaCalendarAlt className="text-[#E87932]" />
                </div>

                <div>
                  <p className="text-sm text-gray-500">Member Since</p>

                  <p className="text-base font-medium text-gray-800 mt-1">
                    {user.createdAt
                      ? new Date(user.createdAt).toLocaleDateString("en-IN", {
                          day: "numeric",
                          month: "long",
                          year: "numeric",
                        })
                      : "-"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
